import { Box, SxProps, Typography } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { ReactNode } from 'react';

type DataChipProps = {
  textColor: string;
  borderColor: string;
  backgroundColor: string;
  label: ReactNode;
  boxSx?: SxProps;
  fontSize?: string;
};

export const DataChip = ({ textColor, borderColor, backgroundColor, label, boxSx = {}, fontSize = '1em' }: DataChipProps) => {
  const boxSxProps = deepmerge({ border: `2px solid`, borderColor, backgroundColor, borderRadius: '4px', px: 1.25, textAlign: 'center' }, boxSx);

  return (
    <Box sx={boxSxProps}>
      <Typography variant="subtitle1" component={'span'} sx={{ color: textColor, fontSize: fontSize }}>
        {label}
      </Typography>
    </Box>
  );
};
